import React from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { Box } from 'widgets/Box'
import { OptionItem } from 'widgets/OptionsDropdown/subcomponents/OptionItem'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useDialogModal } from 'contexts/DialogModalContext'

export const DialogModalPage = ({ ...rest }) => {
  const title = rest?.data?.title
  const primaryAction = rest?.data?.actions?.primary
  const secondaryAction = rest?.data?.actions?.secondary

  const options = rest?.data?.options
  const onOptionSelect = rest?.data?.onOptionSelect

  const insets = useSafeAreaInsets()
  const dialogModalRef = useDialogModal()

  const handleClose = () => {
    dialogModalRef?.current?.dismiss()
  }

  return (
    <Box flex={1} backgroundColor='white' align='center'>
      <Box height={20} align='center' justifyContent='center'>
        <Box height={3} width={40} backgroundColor='grey' borderRadius='sm' />
      </Box>
      <Box flex={1} width='100%' margin={{ top: 'sm', bottom: insets.bottom }}>
        {title?.length && (
          <Box padding='lg' align='center' justifyContent='center'>
            <Text bold fontSize='md' color='black' align='center'>
              {title}
            </Text>
          </Box>
        )}

        {options?.length && (
          <>
            {options?.map((option: string, index: number) => {
              return (
                <OptionItem
                  key={option}
                  option={option}
                  isCancelItem={false}
                  onSelect={() => {
                    onOptionSelect(index)
                    handleClose()
                  }}
                />
              )
            })}
            <OptionItem isCancelItem onSelect={handleClose} />
          </>
        )}

        {secondaryAction && (
          <Box align='center' justifyContent='center'>
            <Box height={1} width='90%' backgroundColor='grey' />
            <Pressable
              disabled={secondaryAction?.onPress === undefined}
              onPress={() => {
                secondaryAction?.onPress()
                handleClose()
              }}
            >
              <Box margin='md'>
                <Text fontSize='sm' color='black' align='center'>
                  {secondaryAction?.title ?? '[Missing title]'}
                </Text>
              </Box>
            </Pressable>
          </Box>
        )}

        {primaryAction && (
          <Box align='center' justifyContent='center'>
            <Box height={1} width='90%' backgroundColor='grey' />
            <Pressable
              disabled={primaryAction?.onPress === undefined}
              onPress={() => {
                primaryAction?.onPress()
                handleClose()
              }}
            >
              <Box margin='md'>
                <Text bold fontSize='sm' color='error' align='center'>
                  {primaryAction?.title ?? '[Missing title]'}
                </Text>
              </Box>
            </Pressable>
          </Box>
        )}
      </Box>
    </Box>
  )
}
